<div class="radio-outer" [class.selected]="selected">
  <div class="radio-inner"></div>
</div>
